export const AIC_STANDALONE_URL = "aic.intech.amazon.dev";
export const CLOUD_FRONT_RAW_URL = ".cloudfront.net";

export const ALLOWED_BASE_DOMAINS = [
  AIC_STANDALONE_URL,
  CLOUD_FRONT_RAW_URL,
  "localhost.a2z.com",
];
